"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetryEvent = void 0;
// tslint:disable
const BaseAvroRecord_1 = require("../../BaseAvroRecord");
class TelemetryEvent extends BaseAvroRecord_1.BaseAvroRecord {
    constructor() {
        super(...arguments);
        this.ipAddress = null;
        this.geo = null;
    }
    schema() {
        return TelemetryEvent.schema;
    }
    subject() {
        return TelemetryEvent.subject;
    }
}
exports.TelemetryEvent = TelemetryEvent;
TelemetryEvent.subject = "telemetry-event";
TelemetryEvent.schema = {
    "type": "record",
    "name": "TelemetryEvent",
    "namespace": "storyblocks.telemetry",
    "fields": [
        {
            "name": "meta",
            "type": {
                "type": "record",
                "name": "Meta",
                "namespace": "storyblocks.common",
                "fields": [
                    {
                        "name": "uuid",
                        "type": "string"
                    },
                    {
                        "name": "emitted",
                        "type": {
                            "type": "long",
                            "logicalType": "timestamp-millis"
                        }
                    },
                    {
                        "name": "origin",
                        "type": {
                            "type": "enum",
                            "name": "Origin",
                            "symbols": [
                                "ACCOUNT_SERVICE",
                                "AFTER_EFFECTS_PLUGIN",
                                "AUDIOBLOCKS",
                                "BILLING_SERVICE",
                                "CONTENT_JOB",
                                "CONTENT_RATING_APP",
                                "CONTENT_SERVICE",
                                "CONTRIBUTOR_PORTAL",
                                "DATA_JOB",
                                "EXAMPLE_SERVICE",
                                "FEATURE_FLAG_SERVICE",
                                "GRAPHICSTOCK",
                                "MISC",
                                "OUTDATED_SCHEMA",
                                "PAYOUT_SERVICE",
                                "PREMIERE_PRO_PLUGIN",
                                "SEARCH_SERVICE",
                                "STORYBLOCKS",
                                "STORYBLOCKS_NEXTJS",
                                "STORYBOARD",
                                "SUBSCRIPTION_SERVICE",
                                "TEMPLATE_EDITOR",
                                "TRANSLATION_SERVICE",
                                "USER_SERVICE",
                                "VIDEOBLOCKS",
                                "WEBHOOKS_GATEWAY"
                            ],
                            "default": "OUTDATED_SCHEMA"
                        }
                    },
                    {
                        "name": "trace",
                        "type": [
                            "null",
                            {
                                "type": "record",
                                "name": "TraceContext",
                                "fields": [
                                    {
                                        "name": "traceId",
                                        "type": "string"
                                    },
                                    {
                                        "name": "pageTraceId",
                                        "type": "string",
                                        "default": ""
                                    },
                                    {
                                        "name": "spanId",
                                        "type": "string"
                                    },
                                    {
                                        "name": "parentId",
                                        "type": "string",
                                        "default": ""
                                    }
                                ]
                            }
                        ],
                        "default": null
                    }
                ]
            }
        },
        {
            "name": "user",
            "type": {
                "type": "record",
                "name": "User",
                "namespace": "storyblocks.common",
                "fields": [
                    {
                        "name": "visitorCookieId",
                        "type": [
                            "null",
                            "string"
                        ]
                    },
                    {
                        "name": "userId",
                        "type": [
                            "null",
                            "int"
                        ]
                    },
                    {
                        "name": "subscriptionId",
                        "type": [
                            "null",
                            "int"
                        ]
                    },
                    {
                        "name": "recurlySubscriptionId",
                        "type": [
                            "null",
                            "string"
                        ],
                        "default": null
                    },
                    {
                        "name": "recurlySubscriptionUuid",
                        "type": [
                            "null",
                            "string"
                        ],
                        "default": null
                    },
                    {
                        "name": "organizationId",
                        "type": [
                            "null",
                            "int"
                        ],
                        "default": null
                    },
                    {
                        "name": "bot",
                        "type": [
                            "null",
                            {
                                "type": "record",
                                "name": "Bot",
                                "fields": [
                                    {
                                        "name": "isBot",
                                        "type": "boolean"
                                    }
                                ]
                            }
                        ],
                        "default": null
                    }
                ]
            }
        },
        {
            "name": "type",
            "type": {
                "type": "enum",
                "name": "TelemetryType",
                "namespace": "storyblocks.telemetry.enums",
                "symbols": [
                    "INCREMENT",
                    "GAUGE",
                    "TIMER",
                    "OUTDATED_SCHEMA"
                ],
                "default": "OUTDATED_SCHEMA"
            }
        },
        {
            "name": "tag",
            "type": "string"
        },
        {
            "name": "value",
            "type": [
                "float",
                "null"
            ]
        },
        {
            "name": "ipAddress",
            "type": [
                "null",
                "string"
            ],
            "default": null
        },
        {
            "name": "geo",
            "type": [
                "null",
                {
                    "type": "record",
                    "name": "Geo",
                    "namespace": "storyblocks.common",
                    "fields": [
                        {
                            "name": "countryCode",
                            "type": "string"
                        },
                        {
                            "name": "country",
                            "type": "string"
                        },
                        {
                            "name": "continent",
                            "type": "string"
                        }
                    ]
                }
            ],
            "default": null
        }
    ]
};
//# sourceMappingURL=TelemetryEvent.js.map